

export async function getCurrentUser() {
    return new Promise(async (resolve, reject) => {
        FirebasePlugin.getCurrentUser(resolve, reject);
    });
}

export async function addDocument(collectionPath, document) {
    return new Promise(async (resolve, reject) => {
        FirebasePlugin.addDocumentToFirestoreCollection(document, collectionPath, resolve, reject);
    });
}

export async function updateDocument(collectionPath, docId, document) {
    return new Promise(async (resolve, reject) => {
        try {
            await getDocument(collectionPath, docId);
            FirebasePlugin.updateDocumentInFirestoreCollection(docId, document, collectionPath, resolve, reject);
        } catch (e) {
            FirebasePlugin.setDocumentInFirestoreCollection(docId, document, collectionPath, resolve, reject);
        }
    });
}

export async function callable(functionName, payload) {
    return new Promise(async (resolve, reject) => {
        const payloadObj = {
            data: payload,
            client: "cordova",
        };
        FirebasePlugin.functionsHttpsCallable(functionName, payloadObj, function (result) {
            console.log("Successfully called function: " + JSON.stringify(result));
            resolve(result);
        }, function (error) {
            console.error("Error calling function: " + JSON.stringify(error));
            reject(error);
        });
    });
}


export async function listenToDocument(collectionName, docId, onSnapshot) {
    console.log(`Listening to collection: ${collectionName}, document: ${docId}`);

    return new Promise(async (resolve, reject) => {
        try {
            FirebasePlugin.listenToDocumentInFirestoreCollection(
                function (event) {
                    switch (event.eventType) {
                        case "id":
                            console.log("Successfully added document listener with id: " + event.id);
                            resolve(event.id);
                            break;
                        case "change":
                            // console.log("Detected document change");
                            // console.log("Source of change: " + event.source);
                            // console.log("Read from local cache: " + event.fromCache);
                            if (event.snapshot) {
                                // console.log("Document snapshot: " + JSON.stringify(event.snapshot));
                                let doc = event.snapshot;
                                doc.updatedAt = convertUnixTimeToFBTimestamp(doc.updatedAt);
                                doc.createdAt = convertUnixTimeToFBTimestamp(doc.createdAt);
                                doc.closedAt = convertUnixTimeToFBTimestamp(doc.closedAt);
                                onSnapshot(doc);
                            }
                            break;
                    }
                },
                reject,
                docId,
                collectionName,
                false
            );
        } catch (err) {
            debugger;
            console.log(err)
            reject(err)
        }
    })
}

export async function getDocument(collectionPath, docId) {
    return new Promise(async (resolve, reject) => {
        FirebasePlugin.fetchDocumentInFirestoreCollection(docId, collectionPath, function (document) {
            console.log("Successfully fetched document: " + JSON.stringify(document));
            resolve(document)
        }, function (error) {
            console.error("Error fetching document: " + error);
            reject(error)
        });
    });
}

export async function getCollection(collectionName, filters) {
    return new Promise(async (resolve, reject) => {
        FirebasePlugin.fetchFirestoreCollection(collectionName, filters, function (documents) {
            console.log("Successfully fetched collection: " + JSON.stringify(documents));
            let docs = [];
            if (documents) {
                for (const [key, value] of Object.entries(documents)) {
                    console.log(`${key}: ${value}`);
                    let doc = value;
                    doc.id = key;
                    doc.updatedAt = convertUnixTimeToFBTimestamp(doc.updatedAt);
                    doc.createdAt = convertUnixTimeToFBTimestamp(doc.createdAt);
                    doc.closedAt = convertUnixTimeToFBTimestamp(doc.closedAt);
                    docs.push(doc);
                }
            }
            resolve(docs);
        }, function (error) {
            console.error("Error fetching collection: " + error);
            reject(error);
        });
    });
}

export async function deleteDocument(collectionPath, docId) {
    FirebasePlugin.deleteDocumentFromFirestoreCollection(docId, collectionPath, function () {
        console.log("Successfully deleted document with id=" + docId);
        resolve();
    }, function (error) {
        console.error("Error deleting document: " + error);
        reject(error);
    });
}

function convertUnixTimeToFBTimestamp(unixString) {
    if (!unixString) return unixString;
    if (typeof unixString != 'string') {
        throw new Error('Expected string but got something else: ${unixString}')

    }
    // console.log(`converting timestamp: ${unixString}`)
    return { seconds: parseInt(unixString) };
}

function convertUnixTimeToDate(unixString) {
    if (!unixString) return null;
    // console.log(`converting timestamp to date: ${unixString}`)
    return new Date(+unixString * 1000);
}

export async function listenToCollection(collectionPath, filters, onSnapshot) {
    return new Promise(async (resolve, reject) => {
        try {
            console.log(`listening to collection: ${collectionPath}, with filters:`)
            console.log(filters)
            FirebasePlugin.listenToCollectionSnapshot(function (event) {
                switch (event.eventType) {
                    case "id":
                        resolve(event.id);
                        console.log("Successfully added collection listener with id=" + event.id);
                        break;
                    case "change":
                        if (event.documents) {
                            let docs = []
                            for (var documentId in event.documents) {
                                var doc = event.documents[documentId];
                                doc.id = documentId;
                                doc.updatedAt = convertUnixTimeToFBTimestamp(doc.updatedAt);
                                doc.createdAt = convertUnixTimeToFBTimestamp(doc.createdAt);
                                doc.closedAt = convertUnixTimeToFBTimestamp(doc.closedAt);
                                docs.push(doc)
                            }
                            onSnapshot(docs)
                        }
                        break;
                }
            },
                reject,
                collectionPath,
                filters,
                false);
        } catch (err) {
            debugger;
            console.log(err)
            reject(err)
        }
    });
}

export function removeListener(listenerId) {
    return new Promise((resolve, reject) => {
        FirebasePlugin.removeFirestoreListener(function () {
            console.log("Successfully removed listener");
            resolve()
        }, function (e) {
            console.error("Error removing listener: " + error);
            reject(e)
        }, listenerId);
    })
}

export function serverTimestamp() {
    const ts = Math.round((new Date().getTime()) / 1000);
    return ts.toString();
}
